import { render, staticRenderFns } from "./boards.vue?vue&type=template&id=269a5b40&"
import script from "./boards.vue?vue&type=script&lang=js&"
export * from "./boards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports